import { useSelector } from "react-redux";
import { hasPermission } from "go-security/services/organizations/selectors";

export const useHasInvoicePermission = () => {
	const hasInvoiceBasicPermission = useSelector(hasPermission("INVOICE_BASIC"));
	const hasInvoiceManagePermission = useSelector(hasPermission("INVOICE_MANAGE"));
	const hasInvoiceClosePermission = useSelector(hasPermission("INVOICE_CLOSE"));
	const hasInvoiceEditDraftPermission = useSelector(hasPermission("INVOICE_DRAFT_EDIT"));
	const hasPermissionsToCreateNewInvoice = hasInvoiceEditDraftPermission || hasInvoiceManagePermission;

	return {
		hasInvoiceBasicPermission,
		hasInvoiceManagePermission,
		hasInvoiceClosePermission,
		hasPermissionsToCreateNewInvoice,
	};
};
